import { AppWindow } from '@insurgrid/common';

export function trackEvent(name?: string, metadata?: Record<string, any>) {
  if (window.analytics && name) {
    window.analytics.track(name, metadata);
  }
}

export async function trackAsyncEvent(
  name?: string,
  metadata?: Record<string, any>,
) {
  if (window.analytics && name) {
    await window.analytics.track(name, metadata);
  }
}

/** does not work !! */
export async function trackIntercomEvent(
  name: string,
  metadata?: Record<string, any>,
) {
  const WINDOW: AppWindow = window;
  if (WINDOW.Intercom) {
    WINDOW.Intercom('trackEvent', name, metadata);
  }
}
